import React from 'react'
import { Row, Cell } from '../Grid'

export default function Body({ children }) {
  return (
    <Row>
      <Cell
        bgcolor="#ffffff"
        style={{
          padding: '32px',
          textAlign: 'left',
          backgroundColor: '#ffffff',
          fontFamily: 'Helvetica,Arial,sans-serif',
          fontSize: '16px'
        }}
      >
        {children}
      </Cell>
    </Row>
  )
}
